<template>
  <div class="product-listing container">
    <div class="row">
      <div
        v-for="(product, index) in products"
        :key="product.id"
        :class="(columns == 3) ? 'col col-xs-6 col-md-4' : 'col col-xs-6 col-md-4 col-lg-3'"
        class=""
      >
        <product-tile
          :product="product"
          :unlazy="index < eagerImageCount"
          :high-priority="index === 0 && index < eagerImageCount"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProductTile from 'theme/components/core/ProductTile'
let lastHero = 0
export default {
  name: 'ProductListing',
  components: {
    ProductTile
  },
  props: {
    products: {
      type: null,
      required: true
    },
    columns: {
      type: [Number, String],
      required: true
    },
    // Render the first N tile images eagerly (real <img src>) so they appear
    // in the SSR HTML and don't wait for IntersectionObserver. Default 0
    // preserves the original behaviour for usages like related products and
    // the my-account widget where the listing is below the fold.
    eagerImageCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    wide (isOnSale, isNew, index) {
      const deltaCondition = index > 0 && ((index - 1) - lastHero) % 2 === 0
      // last image always shouldn't be big, we also need to count from last promoted to check if it will look ok
      const isHero = ((isOnSale === '1' || isNew === '1') && deltaCondition) || (index === this.products.length - 1 && (index - lastHero) % 2 !== 0)
      if (isHero) {
        lastHero = index
      }
      return isHero ? 'col-xs-12' : 'col-xs-6'
    }
  }
}
</script>
